export default __webpack_public_path__ + "static/media/House_icon_tan.5d1a3570.webp";